define('BluePoint.OrderTotalFix.Cart',
    [
        'jQuery',
        'underscore',
        'BluePoint.OrderTotalFix.Utils'
    ],
    function (
        $,
        _,
        Utils
    ) {

        'use strict';

        return {

            mountToApp: function mountToApp(container) {

                var cart = container.getComponent('Cart');

                if (!cart) {
                    console.log('Cart component not found');
                    return;
                }

                /*
                UPDATE LINE UI
                */
                function updateLineUI(line, totalQty) {

                    var quantity = Utils.getQuantity(line);
                    var schedule = Utils.getSchedule(line);

                    if (!schedule || !schedule.length) {
                        return;
                    }

                    var tierPrice = Utils.getTierPrice(schedule, totalQty);
                    if (!tierPrice) {
                        return;
                    }

                    var basePrice = Utils.getBasePrice(schedule);
                    var newAmount = tierPrice * quantity;
                    var itemId = line.item && line.item.internalid;

                    if (!itemId) {
                        return;
                    }

                    /*
                    GET COMPLETE CART LINE
                    */
                    var $line = $('[data-item-id="' + itemId + '"]');
                    if (!$line.length) {
                        return;
                    }

                    /*
                    GET PRICE ELEMENT
                    */
                    var $priceLead = $line.find('.transaction-line-views-price-lead');
                    if (!$priceLead.length) {
                        return;
                    }

                    /*
                    UPDATE PRICE
                    */
                    $priceLead.text('$' + tierPrice.toFixed(2));

                    /*
                    UPDATE AMOUNT
                    */
                    $line.find('.cart-item-summary-amount-value').text('$' + newAmount.toFixed(2));

                    /*
                    STRIKE PRICE
                    */
                    if (tierPrice < basePrice) {
                        if ($line.find('.bp-old-price').length === 0) {

                            $priceLead.after(
                                '<small class="bp-old-price" ' +
                                'style="' +
                                'text-decoration:line-through;' +
                                'margin-left:5px;' +
                                'color:#999;">' +
                                '$' + basePrice.toFixed(2) +
                                '</small>'
                            );

                        } else {
                            $line.find('.bp-old-price').html('$' + basePrice.toFixed(2));
                        }

                    } else {
                        $line.find('.bp-old-price').remove();
                    }

                    /*
                    DISCOUNT MESSAGE
                    */
                    if (tierPrice < basePrice) {
                        if ($line.find('.bp-simulated-price').length === 0) {

                            $line.find('.cart-item-summary-amount-value').after(
                                '<div class="bp-simulated-price" ' +
                                'style="' +
                                'color:green;' +
                                'margin-top:5px;' +
                                'font-size:13px;">' +
                                'Discount tier price applied.' +
                                '</div>'
                            );
                        }

                    } else {
                        $line.find('.bp-simulated-price').remove();
                    }
                }

                /*
                UPDATE SUMMARY UI
                */
                function updateSummaryUI(pricingData) {

                    if (!$('.cart-summary-total').length) {
                        return;
                    }

                    /*
                    SUBTOTAL
                    */
                    $('.cart-summary-amount-subtotal').text('$' + pricingData.frontendSubtotal.toFixed(2));

                    /*
                    TOTAL
                    */
                    cart.getSummary().done(function (summary) {
                        var discount = Math.abs(parseFloat(summary.discounttotal || 0));
                        $('.cart-summary-amount-total').text('$' + (pricingData.frontendSubtotal - discount).toFixed(2));
                    });

                    /*
                    SAVINGS
                    */
                    if ($('.bp-cart-savings').length === 0) {
                        $('.cart-summary-total').after(
                                '<div class="bp-cart-savings" ' +
                                'style="' +
                                'margin-top:15px;' +
                                'color:green;' +
                                'font-weight:bold;">' +
                                'You saved $' +
                                pricingData.totalSavings.toFixed(2) +
                                ' on this order.' +
                                '</div>'
                            );

                    } else {
                        $('.bp-cart-savings').html(
                                'You saved $' +
                                pricingData.totalSavings.toFixed(2) +
                                ' on this order.'
                            );
                    }

                    /*
                    NEXT TIER
                    */
                    if (pricingData.nextTierMessage) {
                        if ($('.bp-next-tier').length === 0) {
                            $('.bp-cart-savings').after(
                                    '<div class="bp-next-tier" ' +
                                    'style="' +
                                    'margin-top:10px;' +
                                    'color:#d97706;' +
                                    'font-weight:600;">' +
                                    pricingData.nextTierMessage +
                                    '</div>'
                                );

                        } else {
                            $('.bp-next-tier').html(pricingData.nextTierMessage);
                        }

                    } else {
                        $('.bp-next-tier').remove();
                    }
                }

                /*
                APPLY
                */
                function applyFrontendDiscounts() {

                    cart.getLines().done(function (lines) {
                        try {
                            var pricingData = Utils.calculateTotals(lines);

                            _.each(lines, function (line) {
                                updateLineUI(line, pricingData.totalQty);
                            });

                            updateSummaryUI(pricingData);

                        } catch (e) {
                            console.log('BluePoint.OrderTotalFix Error =====>', e);
                        }
                    });
                }

                /*
                VERIFY RENDER
                */
                function startRenderVerification() {

                    var attempts = 0;
                    var maxAttempts = 30;
                    var interval = setInterval(function () {

                        attempts++;

                        cart.getLines().done(function (lines) {
                            try {
                                var pricingData = Utils.calculateTotals(lines);
                                var expectedSubtotal = pricingData.frontendSubtotal.toFixed(2);
                                var renderedSubtotal = $.trim($('.cart-summary-amount-subtotal').text());
                                var subtotalMatched = renderedSubtotal.indexOf(expectedSubtotal) !== -1;

                                if (!subtotalMatched) {
                                    applyFrontendDiscounts();

                                } else {
                                    clearInterval(interval);
                                }

                                if (attempts >= maxAttempts) {
                                    clearInterval(interval);
                                }

                            } catch (e) {
                                console.log('Render Verification Error =====>', e);
                            }
                        });

                    }, 500);
                }

                /*
                INITIAL LOAD
                */
                setTimeout(function () {
                    applyFrontendDiscounts();
                    startRenderVerification();
                }, 1500);

                /*
                REFRESH
                */
                function refreshCartPricing() {
                    setTimeout(function () {
                        applyFrontendDiscounts();
                        startRenderVerification();
                    }, 500);
                }

                /*
                EVENTS
                */
                cart.on('afterAddLine', refreshCartPricing);
                cart.on('afterUpdateLine', refreshCartPricing);
                cart.on('afterRemoveLine', refreshCartPricing);
            }
        };
    }
);
